import { ICardDataViewModel } from '../../shared/models/models';
import { NodeMoreLess } from '../tree/node-more-less';

export class MoreLessCardData implements ICardDataViewModel {
    public isVisible: boolean;
    public name: string;
    public value: string;
    public hidableKeys: string[];
    public indent: number;

    constructor(node: NodeMoreLess) {
        this.hidableKeys = node.hidableKeys;
        this.indent = node.indent;
        this.isVisible = true;
    }

}
